import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ProductIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Product",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.31 7.47 16.71.2c-.21-.12-.46-.2-.73-.2s-.52.07-.73.2-12.6 7.27-12.6 7.27c-.43.26-.71.72-.71 1.25v14.55c0 .54.29 1 .72 1.26s12.6 7.28 12.6 7.28c.21.12.46.2.73.2s.52-.07.73-.2 12.6-7.27 12.6-7.27c.44-.26.73-.73.73-1.26V8.74c0-.54-.3-1.01-.74-1.26ZM15.99 3.13l9.7 5.59-3.36 1.94-9.5-5.7L16 3.13Zm-1.45 24.89-9.7-5.59V11.25l3.49 2.01 6.21 3.59v11.18Zm1.45-13.7-9.7-5.59 3.64-2.1 9.51 5.7-3.45 2Zm11.14 8.11-9.7 5.59V16.84l3.38-1.94v3.97a1.451 1.451 0 0 0 2.9 0v-5.66l3.38-1.94.02 11.16Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23.57 30.43h-9.14c-.63 0-1.14-.51-1.14-1.14V17.86c0-.63.51-1.14 1.14-1.14h9.14c1.89 0 3.43 1.54 3.43 3.43v6.86c0 1.89-1.54 3.43-3.43 3.43Zm-8-2.29h8c.63 0 1.14-.51 1.14-1.14v-6.86c0-.63-.51-1.14-1.14-1.14h-8z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.43 30.43H5.29c-1.89 0-3.43-1.54-3.43-3.43v-9.14c0-.63.51-1.14 1.14-1.14h11.43c.63 0 1.14.51 1.14 1.14v11.43c0 .63-.51 1.14-1.14 1.14M4.14 19v8c0 .63.51 1.14 1.14 1.14h8V19z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.43 19H3c-.63 0-1.14-.51-1.14-1.14V8.72c0-1.89 1.54-3.43 3.43-3.43h6.86c1.89 0 3.43 1.54 3.43 3.43v9.14c0 .63-.51 1.14-1.14 1.14ZM4.14 16.71h9.14v-8c0-.63-.51-1.14-1.14-1.14H5.28c-.63 0-1.14.51-1.14 1.14zM27 14.43h-5.71c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43H27c1.89 0 3.43 1.54 3.43 3.43V11c0 1.89-1.54 3.43-3.43 3.43M21.29 4.14c-.63 0-1.14.51-1.14 1.14v5.71c0 .63.51 1.14 1.14 1.14H27c.63 0 1.14-.51 1.14-1.14V5.28c0-.63-.51-1.14-1.14-1.14z"
      })]
    })
  }));
};